import React from "react";
import { TableRow, TableCell, Box, Typography, Avatar } from "@mui/material";

import ActivityBar from "../../../../components/ReportsMemberActivity/ActivityBar";


const projectColors = {
    SG: "#6A0DAD",
    PQ: "#1976d2",
    CB: "#d81b60"
};

const ProjectDetailRow = ({ detail, index, rowDetails }) => {
    let counter = 0;
    for (let j = 0; j <= index; j++) {
        if (rowDetails[j].date) counter++;
    }

    return (
        <TableRow>
            <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
                {detail.date ? counter : ""}
            </TableCell>
            <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'left' }}>
                {detail.date || ""}
            </TableCell>
           

<TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'left' }}>
               <Box
                 display="flex"
                 alignItems="center"
                 gap={1}
                
                 sx={{ cursor: "pointer" }}
               >
                 <Avatar src={detail.avatar} sx={{ width: '40px', height: '40px', fontSize: '13px' }} />
                 <Box>
                   <Typography fontWeight="bold">{detail.name}</Typography>
                   <Typography variant="body2" color="text.secondary">
                     {detail.role}
                   </Typography>
                 </Box>
               </Box>
             </TableCell>






            <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'left' }}>
                <Box display="flex" gap={1}>
                    <Avatar
                        sx={{
                            bgcolor: projectColors[detail.code],
                            width: 40,
                            height: 40,
                            fontSize: '13px',
                        }}
                    >
                        {detail.code}
                    </Avatar>
                    <Box>
                        <Typography fontWeight="bold">{detail.name}</Typography>
                    </Box>
                </Box>
            </TableCell>

           

            <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
                <ActivityBar activity={detail.activity} />
            </TableCell>
           <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
                {detail.time}
            </TableCell>
        </TableRow>
    );
};

export default ProjectDetailRow;